import { useDebugValue } from 'react';
import { useSelector } from 'react-redux';
import { AsyncEntity } from '../../global';
import { RootState } from '../../store';
import { accountsSelectors } from './accounts.state';
import { Account } from './accounts.types';

export const useAccountsState = (): RootState['accounts'] => {
  const accounts = useSelector<RootState, RootState['accounts']>(state => state.accounts);

  useDebugValue(accounts);

  return accounts;
};

export const useAccountsValues = (): Account[] => {
  const accounts = useSelector<RootState, RootState['accounts']>(state => state.accounts);

  const result = accountsSelectors.selectAll(accounts);

  useDebugValue(result);

  return result;
};

export const useAccountById = (id: string): AsyncEntity<Account> | null => {
  const accounts = useSelector<RootState, RootState['accounts']>(state => state.accounts);

  const result = accountsSelectors.selectById(accounts, id) || null;

  useDebugValue(result);

  return result;
};
